// services/publicHttpService.js
import axios from "axios";

require('dotenv').config();

// Create axios instance without authentication interceptors for public routes
const publicInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  }
});

// Response interceptor — errors passed through to calling code for handling
publicInstance.interceptors.response.use(null, error => {
  return Promise.reject(error);
});

export class PublicHTTPService {
  get(url, parameters = {}) {
    if (parameters) {
      return publicInstance.get(url, { params: parameters });
    } else {
      return publicInstance.get(url);
    }
  }

  post(url, payload) {
    return publicInstance.post(url, payload);
  }

  put(url, payload) {
    return publicInstance.put(url, payload);
  }

  patch(url, payload) {
    return publicInstance.patch(url, payload);
  }

  delete(url) {
    return publicInstance.delete(url);
  }
}